import { computed, ref, toRaw, watch } from 'vue'

import axios from 'axios'

const company_sectors = ref([])
const company_sector_filters = ref({})
const filtered_company_sectors = ref([])

export default function useCompanySectors() {
  const listCompanySectors = async (company_id) => {
    await axios
      .get('/api/company_sectors/all-grouped', {
        params: { company_id: company_id },
      })
      .then(function (response) {
        company_sectors.value = filtered_company_sectors.value =
          response.data.data
      })
      .catch(function () {})
  }

  const updateCompanySectorFilters = async () => {
    let filters = toRaw(company_sector_filters.value)

    filtered_company_sectors.value = company_sectors.value.filter((row) => {
      let company_sector = toRaw(row)
      let matches = 0

      for (let key of Object.keys(filters)) {
        if (filters[key].toString().trim() == '') {
          matches++
          continue
        }

        if (
          company_sector[key]
            .toString()
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), '')
            .includes(
              filters[key]
                .toString()
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), ''),
            )
        ) {
          matches++
        }
      }

      return matches == Object.keys(filters).length
    })
  }

  watch(company_sector_filters.value, () => {
    updateCompanySectorFilters()
  })

  return {
    company_sectors: computed(() => company_sectors.value),
    filtered_company_sectors: computed(() => filtered_company_sectors.value),
    company_sector_filters: company_sector_filters,
    listCompanySectors,
  }
}
